import { Link } from '@tanstack/react-router';
import { Button } from '../ui/button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background text-foreground">
      <h1 className="text-8xl font-bold text-muted-foreground">404</h1>
      <h2 className="text-heading-h6">Page not found</h2>
      <p className="text-body-sm-regular text-muted-foreground">The page you&apos;re looking for doesn&apos;t exist.</p>
      <Button asChild variant="outline">
        <Link to="/">Go home</Link>
      </Button>
    </div>
  );
}
